/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_top_ups_modal_pse_id_type_passport = /** @type {(inputs: {}) => string} */ () => {
	return `Pasaporte`
};

const en_top_ups_modal_pse_id_type_passport = /** @type {(inputs: {}) => string} */ () => {
	return `Passport`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const top_ups_modal_pse_id_type_passport = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.top_ups_modal_pse_id_type_passport(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("top_ups_modal_pse_id_type_passport", locale)
	if (locale === "es") return es_top_ups_modal_pse_id_type_passport(inputs)
	return en_top_ups_modal_pse_id_type_passport(inputs)
};
export { top_ups_modal_pse_id_type_passport as "top_ups.modal.pse_id_type_passport" }